import ApprovedDeposit from './ApprovedDeposit';

export default ApprovedDeposit;
